import { ActiveFormStateModel } from '../interface/active-form.interface';

export class FormSetHasActiveForm {
    static type = '[ActiveForm] Set Has Active Form';

    constructor(public hasActiveForm: boolean) {}
}

export class FormSetIsValid {
    static type = '[ActiveForm] Set Is Valid';

    constructor(public isValid: boolean) {}
}

export class FormSetIsDirty {
    static type = '[ActiveForm] Set Is Dirty';

    constructor(public isDirty: boolean) {}
}

export class FormSetIsSubmitted {
    static type = '[ActiveForm] Set Is Submitted';

    constructor(public isSubmitted: boolean) {}
}

export class SetFormState {
    static type = '[ActiveForm] Set Form State';

    constructor(public state: ActiveFormStateModel) {}
}
